export const AccountDataColumns = [
  { field: "id", headerName: "User Name", flex: 1 },
  { field: "firstName", headerName: "First Name", flex: 1 },
  { field: "lastName", headerName: "Last Name", flex: 1 },
  {
    field: "phoneNumber",
    headerName: "Phone Number",
    flex: 1,
  },
  { field: "email", headerName: "Email", flex: 1 },
  {
    field: "role",
    headerName: "Role",
    flex: 1,
  },
];

export const DataExplorerAssetColumns = [
  { field: "site", headerName: "Site", flex: 1 },
  { field: "asset", headerName: "Asset", flex: 1 },
  { field: "numberOfTickets", headerName: "n° Ticket", flex: 1 },
  {
    field: "timeSpentToSolve",
    headerName: "Time Spent to Solve (h)",
    flex: 1,
  },
  { field: "cost", headerName: "Cost (€)", flex: 1 },
  { field: "budget", headerName: "Budget if any (€)", flex: 1 },
];

export const DataExplorerAlarmColumns = [
  { field: "site", headerName: "Site", flex: 1 },
  { field: "building", headerName: "Building", flex: 1 },
  { field: "asset", headerName: "Asset", flex: 1 },
  { field: "date", headerName: "Date", flex: 1 },
  {field: "severity",headerName: "Severity",flex: 1},
  { field: "ticketStatus", headerName: "Current Ticket Status", flex: 1 },
];

export const DataExplorerTicketColumns = [
  { field: "site", headerName: "Site", flex: 1 },
  { field: "asset", headerName: "Asset", flex: 1 },
  { field: "building", headerName: "Building", flex: 1 }, // Added ID column
  { field: "severity", headerName: "Severity", flex: 1 }, // Added Severity column
  { field: "ticketStatus", headerName: "Ticket Status", flex: 1 }, // Added Ticket Status column
  { field: "cost", headerName: "Cost (€)", flex: 1 },
];



